// NPM Imports
import React, { useEffect, useState } from "react";
import { Label, Input } from "../../../revvComponents";

// Components Imports

// Actions Imports

// Internal Imports

// Destructuring

export default function RevvEditorToogleField({
  id,
  isDisabled,
  isMagicLinkPage,
  isDocInFinalStage,
  isReadOnly,
  className,
  toogleValue,
  updateField,
  sectionId,
}) {
  // local states
  const [isChecked, handleCheckbox] = useState(toogleValue);

  // CDM
  useEffect(() => {
    handleCheckbox(toogleValue);
  }, [toogleValue]);

  const _handleToggle = value => {
    if (!isDisabled && !isDocInFinalStage && !isMagicLinkPage && !isReadOnly) {
      handleCheckbox(value);
      updateField(value, "TOGGLE");
    }
  };

  if (isReadOnly) {
    if (isChecked) {
      className += " checked ";
    }
  }
  const checkboxId = `toggle_foeld_${id}_${sectionId}`;
  return (
    <span className={className} contentEditable={false}>
      <Label htmlFor={checkboxId}>
        <Input
          key={`${checkboxId}-${isChecked ? "checked" : "unchecked"}`}
          id={checkboxId}
          name={checkboxId}
          data-test={"revveditor-checkboxonly-input-field"}
          type={"checkbox"}
          checked={isChecked}
          onChange={() => _handleToggle(!isChecked)}
          disabled={isDisabled}
        />
      </Label>
    </span>
  );
}
